import Icon from '../../components/Icon.vue'

Icon.register({
  'brands/ns8': {
    width: 640,
    height: 512,
    paths: [
      {
        d: 'M187.1 159.9L152.9 273.6 98.4 159.9H49L0 320H44.9L76 213.5 126.6 320H183.5L232 159.9H187.1zM639.6 159C636.7 141 615.7 130.9 597.5 127.7 552.9 119.9 495.6 144 509 186.5V186.6C465.2 195.3 434.7 213.4 414.8 234.8 411.8 225 401.2 218.2 380.8 218.2H293.2C283.9 218.2 280.3 215.9 281.7 210.8 283.3 205.3 283.6 204 285.4 198.6 287.5 192.2 293.2 191.5 298.7 191.5H432.2L441.9 160C302.2 160 297.4 159.5 281.8 161.2 269.5 162.5 258.3 166 251.2 176.2 244.4 186.1 236.8 211.8 233.6 223.3 228.2 242.7 233 251.9 266.4 251.9H353.7C361.5 251.9 362.5 254.6 361.4 258.5 360.3 262.9 358.6 268.5 356.9 273.1 355.3 277.3 352.2 280.5 343.1 280.5H216.3L204.7 320C344.6 320 350 319.4 365.6 317.7 372.2 317 378.6 315.6 384.1 312.8 384.3 316.5 384.6 320.1 385.3 323.6 390.7 354.1 412.7 375.9 442.1 383.1 490.7 395 550.8 366.3 577.2 315.1 595.9 278.9 591.3 238.9 573.8 209.6H573.9C603.5 203.7 644.2 187.6 639.6 159zM530.7 263.7C524.8 293.2 494.1 311.5 469.1 307.6 438.2 302.8 430.6 268.1 455 242.8 471.2 226 500.2 218.8 523.5 215.9 530.2 230 533.8 247.9 530.7 263.7zM552.5 180.6C548.3 174.6 542.7 162.1 550 154.3 556.7 147.1 570.9 144.2 581.8 146.6 597.1 150 601.5 162.5 586.7 171 576 177.1 563.1 179.1 552.5 180.6z'
      }
    ]
  }
})



//////////////////
// WEBPACK FOOTER
// ./~/vue-awesome/icons/brands/ns8.js
// module id = F0t9
// module chunks = 144